import { useState } from "react";
import ModuleHeader from "../../components/ModuleHeader";
import usePermission from "../../hooks/usePermission";
import SalaryStatusTab from "./SalaryStatusTab";
import NOCTab from "./NOCTab";
import PledgeTab from "./PledgeTab";
import RiderExpensesTab from "./RiderExpensesTab";
import EMIManagementTab from "./EMIManagementTab";
import EMIKpiTab from "./EMIKpiTab";

const TABS = [
  { key: "salary-status", label: "Salary Status" },
  { key: "noc", label: "NOC Certificate" },
  { key: "pledge", label: "Pledge" },
  { key: "rider-expenses", label: "Rider Expenses" },
  { key: "emi-management", label: "EMI Management" },
  { key: "emi-kpi", label: "EMI KPI Summary" },
];

const TAB_COMPONENTS = {
  "salary-status": SalaryStatusTab,
  noc: NOCTab,
  pledge: PledgeTab,
  "rider-expenses": RiderExpensesTab,
  "emi-management": EMIManagementTab,
  "emi-kpi": EMIKpiTab,
};

export default function PayrollExpenses() {
  const [activeTab, setActiveTab] = useState("salary-status");
  const { canView } = usePermission("payrollExpenses");

  const ActiveComponent = TAB_COMPONENTS[activeTab];

  return (
    <div>
      <ModuleHeader
        title="Payroll & Expenses"
        tabs={TABS}
        activeTab={activeTab}
        onTabChange={setActiveTab}
      />
      <div style={{ padding: 24 }}>
        {canView ? (
          ActiveComponent && <ActiveComponent />
        ) : (
          <p style={{ textAlign: "center", color: "#94a3b8" }}>
            You do not have permission to view this module.
          </p>
        )}
      </div>
    </div>
  );
}
